import { render, staticRenderFns } from "./AssetCard.vue?vue&type=template&id=fa0e9a1c"
import script from "./AssetCard.vue?vue&type=script&lang=js"
export * from "./AssetCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports